import { render, staticRenderFns } from "./CheckAuth.vue?vue&type=template&id=963b1994&scoped=true"
import script from "./CheckAuth.vue?vue&type=script&lang=js"
export * from "./CheckAuth.vue?vue&type=script&lang=js"
import style0 from "./CheckAuth.vue?vue&type=style&index=0&id=963b1994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963b1994",
  null
  
)

export default component.exports